import React from 'react';
import {connect} from 'react-redux';
import {changeInput} from "../lib/actions";
import {MAX_BRACELET_LETTERS_PER_LINE, BRACELET} from "../../constants";

class InputHeader extends React.Component {
    getDescription(orientation) {
        switch (orientation) {
            case BRACELET.STANDARD:
                return 'Up to seven characters joined on a chain.';
            case BRACELET.SPACED:
                return 'Up to seven characters spaced on chain.';
            case BRACELET.SIDEWAYS:
                return 'Up to seven sideways characters spaced on chain.';
        }
    }

    render() {
        return (
            <div className="customizer__header">
                <h4>
                    {this.props.braceletOrientation.description} Text
                </h4>
                <p>{this.getDescription(this.props.braceletOrientation)}</p>
            </div>
        );
    }
}

class Input extends React.Component {
    onChange(value) {
        if (/[^a-zA-Z0-9&]/.test(value)) {
            return;
        }

        if (value.length && value.length > MAX_BRACELET_LETTERS_PER_LINE) {
            return;
        }

        this.props.onChange(value.toUpperCase());
    }

    render() {
        let counterClassName = 'customizer-input__count';

        if (!this.props.input || this.props.input.length === 0) {
            counterClassName += ' customizer-input__count-error';
        }

        return (
            <>
                <InputHeader braceletOrientation={this.props.braceletOrientation}/>
                <div className='customizer-input'>
                    <div className="customizer-input__line">
                        <input className='customizer-input__field' type='text' value={this.props.input} onChange={(e) => this.onChange(e.target.value)}/>
                        <div className={counterClassName}>{this.props.input ? this.props.input.length : 0}/{MAX_BRACELET_LETTERS_PER_LINE}</div>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        input: state.input,
        braceletOrientation: state.braceletOrientation,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onChange: (input) => {
            dispatch(changeInput(input));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Input);
